import moment from 'moment';

export const filterList = ({ appointments = [], filters, startDate, endDate, assocStores }) => {
  const allStores = assocStores.filter(store => store.id !== 0).map(item => item.id);

  return appointments?.filter(item => {
    const filterStore =
      filters.store.length === 0
        ? allStores.includes(Number(item?.activity_store_id))
        : filters.store.includes(Number(item?.activity_store_id)?.toString());
    const filterStatus = filters?.status?.length === 0 || filters?.status?.includes(item.status_code);
    const filterAssociate =
      filters.associate.length === 0 || filters.associate.includes(Number(item?.activity_associate_id)?.toString());
    // Convert appointment date from UTC to local timezone for comparison
    // Compare by day only to avoid timezone edge cases where times shift dates
    const activityDateLocal = moment(item.activity_date).local();
    const filterTimeSpan = activityDateLocal.isBetween(
      moment(startDate).startOf('day'),
      moment(endDate).endOf('day'),
      'day',
      '[]'
    );
    const filterSource =
      filters.source.length === 0 || filters.source.includes(item?.activity_source);
    return filterStore && filterAssociate && filterTimeSpan && filterSource && filterStatus;
  });
};

export const filterStatList = ({ appointments = [], filters, startDate, endDate }) => {
  return appointments?.filter(item => {
    // Convert appointment date from UTC to local timezone for comparison
    // Compare by day only to avoid timezone edge cases where times shift dates
    const appointmentDateLocal = moment(item.appointment_date).local();
    const filterTimeSpan = appointmentDateLocal.isBetween(
      moment(startDate).startOf('day'),
      moment(endDate).endOf('day'),
      'day',
      '[]'
    );
    const filterStatus = filters?.status?.length === 0 || filters?.status?.includes(item.status_code);
    const filterAssociate =
      filters.associate.length === 0 || filters.associate.includes(Number(item?.associate_id)?.toString());
    const filterStore =
      filters.store.length === 0
        ? true
        : filters.store.includes(item?.store_id?.toString());
    const filterSource =
      filters.source.length === 0 || filters.source.includes(item?.appointment_source);
    return filterTimeSpan && filterStatus && filterAssociate && filterStore && filterSource;
  });
};
